import {showNotification} from "../../notifications/notification.action";
import {seamlessLoadTasks} from "../myTasks.action";
import * as Api from "utils/api/api";
import {translate} from "../../translations/translations.wrapper.jsx";
import {handleTask} from "./handleTask.action";
import * as logger from "../../../utils/logger.function";
import {getTask, getUsersShowCommentOnApprove} from "../../store/application.reducers";
import {
    replacePlaceholderInMessage,
    getTaskUserDescription,
    addTasksAmount,
} from "utils/valueFormatter.function";
import {handleError} from "utils/errorHandle.function";
import {approveActionRunning, approveActionStop} from "./taskAction.action";

const ERROR = "error";

export function approveMultipleTasks(tasksData, comment, version, skipRestart, isFromBatch = false, navigate) {
    return async function (dispatch, getState) {
        const state = getState();
        // direct approve:
        const taskIds = Object.keys(tasksData);
        const onlyOne = taskIds.length === 1;
        const showCommentOnApprove = getUsersShowCommentOnApprove(state);


        const results = [];
        try {

            dispatch(approveActionRunning());
            for (const id of taskIds) {
                if (!comment && (
                    isFromBatch ||
                    !showCommentOnApprove ||
                    !onlyOne)) {


                    results.push(
                      await Api.getDraftComment(tasksData[id].documentUid).then(function (response) {
                            const currentComment = response?.text || "";
                            return Api.approveTask(id, currentComment, version, skipRestart, tasksData[id].uid).then((response) => {

                                if (onlyOne)
                                    dispatch(singleTaskToast(id, response.message, isFromBatch));

                            }).catch(error => {
                                logger.debug("Task cannot be approved because of unapproved lines " + error.errorMessages);
                                throw error;
                            });
                        }),
                    );
                } else {

                    results.push(
                        await Api.approveTask(id, comment, version, skipRestart, tasksData[id].uid).then((response) => {
                            if (onlyOne)
                                dispatch(singleTaskToast(id, response.message, isFromBatch));


                        }).catch(error => {
                            logger.debug("Task cannot be approved because of unapproved lines " + error.errorMessages);
                            throw error;
                        }),
                    );
                }
            }
            //don't automatically move from task details if there's an error
            if (onlyOne && results[0] === ERROR) {
                return;
            }
            // positive notification
            if (!onlyOne) {
                dispatch(multipleTasksToast(taskIds, isFromBatch));
            }
            // resolve for last
            const last = taskIds.slice().pop();

            dispatch(approveActionStop());
            dispatch(handleTask(last, navigate));
        } catch (error) {
            logger.error("redux.approveMultipleTasks", error);
            //refresh task list
            dispatch(seamlessLoadTasks());
            handleError(error);
        }
    };
}

function singleTaskToast(id, response, isFromBatch) {
    return function (dispatch, getState) {
        const state = getState();
        let message = "";

        const task = getTask(id, state);
        if (isFromBatch) {
            let text = task.task.amount ? task.task.amount + " " + task.task.currency : "";
            message = translate(state, "popUp.approve.approveAndPaySingle", text);
        } else
            message = replacePlaceholderInMessage(response, getTaskUserDescription(task));

        dispatch(showNotification(message));
    };
}

function multipleTasksToast(ids, isFromBatch) {
    return function (dispatch, getState) {
        const state = getState();
        let message = "";

        if (isFromBatch) {
            let tasks = ids.map(id => {
                return getTask(id, state).task;
            });

            let cost = addTasksAmount(tasks);

            message = cost ? translate(state, "popUp.approve.approveAndPayMultipleWithCost", ids.length, cost) :
                translate(state, "popUp.approve.approveAndPayMultipleWithoutCost", ids.length);
        } else
            message = translate(state, "popUp.approve.actionSuccess", ids.length);
        dispatch(showNotification(message));
    };
}